import { ISMT_DotTaoDe_Request } from "../../model/request/de-thi/ISMT_DotTaoDe_Request";
import { IProcessRequest } from "../../model/request/IProcessRequest";
import { ISMT_DotTaoDe } from "../../model/respone/de-thi/ISMT_DotTaoDe";
import { apiClient } from "../apiClient";
export const DOT_TAO_DE_ENDPOINT = "dot-tao-de";
export const dotTaoDeApi = {
  Select: (payload: ISMT_DotTaoDe_Request) =>
    apiClient.post(`${DOT_TAO_DE_ENDPOINT}/select-by-request`, payload),
  SelectById: (id: number) => apiClient.get(`${DOT_TAO_DE_ENDPOINT}/${id}`),
  Insert: (payload: ISMT_DotTaoDe) =>
    apiClient.post(`${DOT_TAO_DE_ENDPOINT}`, payload),
  Update: (payload: ISMT_DotTaoDe) =>
    apiClient.put(`${DOT_TAO_DE_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${DOT_TAO_DE_ENDPOINT}/${id}`),
  DeleteMultiple: (ids: number[]) =>
    apiClient.put(`${DOT_TAO_DE_ENDPOINT}/delete-multiple`, ids),
  CreateDeThiAsync: (request: IProcessRequest<number>) =>
    apiClient.put(
      `${DOT_TAO_DE_ENDPOINT}/create-de-thi?process_id=${request.process_id}`,
      request.payload
    ),
};
